import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLocale } from "../../contexts/LocaleContext";
import { applyPageMetadata, currentSeoLocale, isSeoTargetRoute, markPrerenderReady, seoCopy } from "../../lib/seo";

const supplierMeta = {
  "/suppliers": ["Leverancier van bevestigingsmaterialen worden | ARAMFIX", "Meld uw bedrijf en assortiment bevestigingsmaterialen aan en ontdek samenwerking met het internationale ARAMFIX-inkoopnetwerk."],
  "/suppliers/manufacturers": ["Internationale verkoop voor fastenerfabrikanten | ARAMFIX", "Breng uw productie-expertise en assortiment bevestigingsmaterialen naar nieuwe markten via ARAMFIX."],
  "/suppliers/wholesalers": ["Internationale verkoop voor fastenergroothandels | ARAMFIX", "Maak uw magazijnvoorraad bevestigingsmaterialen vindbaar voor internationale inkoopvragen via ARAMFIX."],
  "/suppliers/how-it-works": ["Zo werkt leverancierssamenwerking | ARAMFIX", "Lees hoe productdata, commerciële afspraken, onboarding en orders voor ARAMFIX-leveranciers werken."],
  "/suppliers/apply": ["Gratis aanmelden als ARAMFIX-leverancier", "Stel uw bedrijf en assortiment bevestigingsmaterialen gratis voor aan het ARAMFIX-partnershipteam."],
};

const purchaserMeta = {
  nl: ["Voor inkopers: webshop, veilingen en maatwerk | ARAMFIX", "Zoek bevestigingsmaterialen bij ARAMFIX. Bestel via de webshop, ontdek veilingpartijen of vraag een offerte aan voor specialistisch aanbod en maatwerk."],
  en: ["For purchasers: webshop, auctions and custom supply | ARAMFIX", "Search for fasteners at ARAMFIX. Order through the webshop, discover auction lots or request a quote for specialist and custom supply."],
  de: ["Für Einkäufer: Webshop, Auktionen und Sonderteile | ARAMFIX", "Suchen Sie Befestiger bei ARAMFIX. Bestellen Sie im Webshop, entdecken Sie Auktionspartien oder fragen Sie Spezial- und Maßanfertigungen an."],
};

const utilityPattern = /^\/(?:search|rfq(?:\/[^/]+)?|account|cart|checkout|webshop\/checkout|complete-warehouse-order\/[^/]+)$/;

export const RouteMetadata = () => {
  const { pathname } = useLocation();
  const { locale: contextLocale } = useLocale();
  useEffect(() => {
    const locale = currentSeoLocale(contextLocale);
    const copy = seoCopy[locale] || seoCopy.en;
    const indexableLocale = isSeoTargetRoute();
    document.documentElement.lang = contextLocale;
    if (pathname.startsWith("/product/") || pathname.startsWith("/products/")) return;
    if (pathname === "/products") {
      applyPageMetadata({ title: copy.productsTitle, description: copy.productsDescription, internalPath: pathname, locale, indexable: indexableLocale });
      return;
    }
    if (pathname === "/") {
      applyPageMetadata({ title: copy.homeTitle, description: copy.homeDescription, internalPath: pathname, locale, indexable: indexableLocale });
      markPrerenderReady();
      return;
    }
    if (pathname === "/purchasers") {
      const meta = purchaserMeta[locale] || purchaserMeta.en;
      applyPageMetadata({ title: meta[0], description: meta[1], internalPath: pathname, locale, indexable: indexableLocale, image: "/assets/aramfix/home-content/warehouse-3.jpg" });
      markPrerenderReady();
      return;
    }
    if (supplierMeta[pathname]) {
      applyPageMetadata({ title: supplierMeta[pathname][0], description: supplierMeta[pathname][1], internalPath: pathname, locale, indexable: locale === "nl" });
      markPrerenderReady();
      return;
    }
    if (utilityPattern.test(pathname)) {
      applyPageMetadata({ title: "ARAMFIX", description: copy.homeDescription, internalPath: pathname, locale, indexable: false });
      markPrerenderReady();
      return;
    }
    applyPageMetadata({ title: copy.notFoundTitle, description: copy.homeDescription, internalPath: pathname, locale, indexable: false });
    markPrerenderReady();
  }, [pathname, contextLocale]);
  return null;
};